import { ReactNode } from 'react';
import { useSessionTimeout } from '@/hooks/useSessionTimeout';
import { SessionTimeoutWarning } from './SessionTimeoutWarning';

interface SessionTimeoutProviderProps {
  children: ReactNode;
}

export const SessionTimeoutProvider = ({ children }: SessionTimeoutProviderProps) => {
  const { showWarning, extendSession, handleTimeout } = useSessionTimeout();
  
  return (
    <>
      {children}
      <SessionTimeoutWarning
        isVisible={showWarning}
        onExtend={extendSession}
        onTimeout={handleTimeout}
        countdownSeconds={60}
      />
    </>
  );
};